<template>
  <v-layout v-if="!$apollo.loading" column class="wrapper">
    <v-flex class="title-screen" xs12>
      <span>{{ adminText('workflowsAll.floor_plan_overview_36d5a0f', 'Floor plan overview') }}</span>
    </v-flex>
    <v-select
      v-if="eventTemplateId"
      v-model="selectedEventId"
      :items="workflowUi(performanceDates)"
      :label="adminText('workflowsAll.performance_63c9045', 'Performance')"
      item-text="from"
      item-value="id"
      box
      style="max-width: 1000px"
    />
    <spinner v-if="!showFloorPlan" />
    <div v-else-if="!venue">{{ adminText('workflowsAll.this_event_does_not_have_a_floor_plan_a553e18', 'This event does not have a floor plan.') }}</div>
    <div v-else class="floor-plan-overview-wrapper">
      <div class="floor-plan-wrapper">
        <div class="card-title">{{ adminText('workflowsAll.floor_plan_d5786d3', 'Floor plan') }}</div>
        <div class="controls-wrapper">
          <div class="floor-plan-toggle">
            <button
              type="button"
              :class="[
                'floor-plan-toggle-btn',
                { 'floor-plan-toggle-btn--active': changeSelectOption === 1 },
              ]"
              @click="handleSelectOptions(1)"
            >
              <img src="/assets/seat-logo.svg" :alt="adminText('workflowsAll.seats_05d560f', 'seats')" class="floor-plan-toggle-icon">
              <span class="floor-plan-button-text">{{ adminText('workflowsAll.seat_b90b325', 'Seat') }}</span>
            </button>
            <button
              type="button"
              :class="[
                'floor-plan-toggle-btn',
                { 'floor-plan-toggle-btn--active': changeSelectOption === 2 },
              ]"
              @click="handleSelectOptions(2)"
            >
              <img src="/assets/row.svg" :alt="adminText('workflowsAll.rows_6c30d26', 'rows')" class="floor-plan-toggle-icon">
              <span class="floor-plan-button-text">{{ adminText('workflowsAll.row_9bf7a8e', 'Row') }}</span>
            </button>
            <button
              type="button"
              :class="[
                'floor-plan-toggle-btn',
                { 'floor-plan-toggle-btn--active': changeSelectOption === 3 },
              ]"
              @click="handleSelectOptions(3)"
            >
              <img src="/assets/sectionsvg.svg" :alt="adminText('workflowsAll.sections_063b114', 'sections')" class="floor-plan-toggle-icon">
              <span class="floor-plan-button-text">{{ adminText('workflowsAll.group_171a060', 'Group') }}</span>
            </button>
          </div>

          <div class="controls-actions">
            <button type="button" class="restart-btn" @click="onRestartClick">
              <span class="material-icons">replay</span>
            </button>
            <button type="button" class="save-btn" @click="onSaveClick">{{ adminText('workflowsAll.save_508156a', 'SAVE') }}</button>
          </div>
        </div>
        <div class="floor-plan-container">
          <div ref="objectContainerRef" class="object-container">
            <spinner v-if="coloringInProgress" />
            <object
              v-show="!coloringInProgress"
              id="svgfile"
              :key="selectedEventId"
              :data="workflowUi(venue.imageUrl)"
              type="image/svg+xml"
              :style="floorPlanSvgStyle"
              @load="onSvgObjectLoad"
            />
            <span
              v-if="seatInfoVisible"
              class="tooltip"
              :style="{ top: seatInfoPosition.top, left: seatInfoPosition.left }"
            >
              {{ adminText('workflowsAll.r_ff65cdd', 'R:') }} {{ workflowLabel(extractString(hoveredSeat).row) }} {{ adminText('workflowsAll.s_6d77ecf', 'S:') }} {{ workflowLabel(extractString(hoveredSeat).seat) }}
              <span v-if="hoveredSeatHolderInfo"> <br>{{ workflowLabel(hoveredSeatHolderInfo.name) }} </span>
              <span v-if="hoveredPlanName"> <br>{{ workflowLabel(hoveredPlanName) }} </span>
            </span>
          </div>
        </div>

        <div class="tickets-container tickets-container--below">
          <div class="additional-seat-info-container">
            <div class="additional-seat-info-title">{{ adminText('workflowsAll.info_4b631f6', 'Info') }}</div>
            <div class="additional-items">
              <ticket-chip
                :label="adminText('workflowsAll.sold_e6560d9', 'Sold')"
                :number="
                  audienceCapacity -
                    availableSeats.length -
                    disabledSeats.length -
                    reservedTicketsLength
                "
              >
                <span slot="left-slot" class="circle sold-circle" />
              </ticket-chip>
              <ticket-chip :label="adminText('workflowsAll.booked_13e7a65', 'Booked')" :number="reservedTicketsLength">
                <span slot="left-slot" class="circle booked-circle">{{ adminText('workflowsAll.r_0657655', 'R') }}</span>
              </ticket-chip>
              <ticket-chip :label="adminText('workflowsAll.available_7c62a14', 'Available')" :number="availableSeats.length">
                <span slot="left-slot" class="circle available-circle" />
              </ticket-chip>
              <ticket-chip :label="adminText('workflowsAll.unavailable_2c9c1f7', 'Unavailable')" :number="disabledSeats.length">
                <span slot="left-slot" class="circle unavailable-circle" />
              </ticket-chip>
            </div>
          </div>
        </div>
      </div>

      <div class="tickets-container">
        <div class="card-title">{{ adminText('workflowsAll.tickets_5c622a5', 'Tickets') }}</div>
        <div class="mark-as-wrapper">
          <div class="mark-as-title">{{ adminText('workflowsAll.mark_as_226d8fd', 'Mark as') }}</div>
          <button
            type="button"
            :class="[
              'mark-unavailable-btn',
              selectedSeatIds.length &&
                findSelectedSeatsType() === 'available' &&
                'mark-unavailable-btn--ready',
              selectedSeatIds.length &&
                findSelectedSeatsType() === 'unavailable' &&
                'mark-unavailable-btn--marked',
            ]"
            :disabled="!selectedSeatIds.length"
            @click="onChangeSeatStatus"
          >
            <span class="mark-unavailable-left">
              <span class="mark-dot" />
              <span class="mark-unavailable-text">{{ adminText('workflowsAll.unavailable_2c9c1f7', 'Unavailable') }}</span>
            </span>

            <span
              v-if="selectedSeatIds.length && findSelectedSeatsType() === 'available'"
              class="mark-unavailable-right"
            >
              <span class="mark-link-icon material-icons">link</span>
            </span>
            <span
              v-else-if="selectedSeatIds.length && findSelectedSeatsType() === 'unavailable'"
              class="mark-unavailable-right"
            >
              <span class="mark-check material-icons">done_all</span>
              <span class="mark-as-text">{{ adminText('workflowsAll.marked_as_fadf57d', 'Marked as') }}</span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <seat-details-modal
      v-if="selectedSeatData.data"
      :visible="seatDetailsModalVisible"
      :seat-details="selectedSeatData"
      @close="closeSeatDetailsModal"
    />
    <simple-snackbar :open.sync="snackbar.open" :message-prop="workflowLabel(snackbar.messageProp)" :color="snackbar.color" />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import Spinner from '../shared/spinner.vue'
import {
  GET_EVENTS_BY_EVENT_TEMPLATE_ID,
  GET_FLOOR_PLAN_AVAILABILITY_OVERVIEW_DATA,
} from '@/graphql/event.graphql'
import moment from 'moment/moment'
import TicketChip from '@/components/shared/ticket-chip.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'
import { difference } from 'lodash'
import { updateVenueAvailability } from '@/http'
import { SeatState, Venue } from '@/types'
import sumBy from 'lodash/sumBy'
import SeatDetailsModal from './seat-details-modal.vue'
import { getFloorPlanOverviewSeatDetailsByTicketLocation } from '@/http'
import * as svgPanZoom from 'svg-pan-zoom'
import * as Hammer from 'hammerjs'

// Define OrderItemType (using an object for simplicity in Vue <script>)
const OrderItemType = {
  TICKET: 'ticket',
  ARTICLE: 'article',
  PREPAID_COUPON: 'prepaidCoupon',
  MEMBERSHIP_PLAN: 'membershipPlan',
  THEATER_SUBSCRIPTION: 'theaterSubscription',
}

const SUBSCRIPTION_SEAT_COLOR = '#800080' // Purple for subscription seats

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-floor-plan-overview',
  components: {
    SimpleSnackbar,
    TicketChip,
    Spinner,
    SeatDetailsModal,
  },
  props: {
    eventId: String,
    eventTemplateId: String,
    organizationSlug: String,
  },
  data() {
    return {
      selectedEventId: null,
      performanceDates: [],
      showFloorPlan: false,
      venue: null,
      orderItems: [],
      availableSeats: [],
      initialAvailableSeats: [],
      disabledSeats: [],
      initialDisabledSeats: [],
      coloringInProgress: true,
      audienceCapacity: 0,
      updatingFloorPlan: false,
      selectedSeatIds: [],
      changeSelectOption: 1,
      seatIdsCache: [],
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      snackbar: {},
      seatInfoVisible: false,
      hoveredSeat: null,
      seatInfoPosition: null,
      reservedTicketsLength: 0,
      seatHolders: [],
      hoveredSeatHolderInfo: null,
      hoveredPlanName: null,
      seatDetailsModalVisible: false,
      selectedSeatData: {},
      clickStartX: null,
      clickStartY: null,
      startX: null,
      startY: null,
      multiTouch: false,
      svgClickListenersInitialized: false,
    }
  },
  computed: {
    floorPlanSvgStyle() {
      if (!this.isArenaFanPitVenue()) {
        return { width: '100%' }
      }

      return {
        width: '100%',
        height: 'min(72vh, 720px)',
        objectFit: 'contain',
      }
    },
    subscriptionUsedCount() {
      try {
        const subItems = (this.orderItems || []).filter(
          oi => oi.isSubscription || oi.type === 'THEATER_SUBSCRIPTION',
        )

        return subItems.reduce((acc, oi) => acc + ((oi.soldSeats && oi.soldSeats.length) || 0), 0)
      } catch (e) {
        return 0
      }
    },
  },
  watch: {
    async selectedEventId(val) {
      if (!val) return
      // Reset state to avoid flashing old SVG/colors
      this.coloringInProgress = true
      this.venue = null
      this.availableSeats = []
      this.disabledSeats = []
      this.orderItems = []
      this.seatHolders = []
      this.svgClickListenersInitialized = false
      this.seatIdsCache = []
      await this.fetchFloorPlanAvailabilityData()
    },
  },
  created() {
    if (this.eventTemplateId) {
      this.fetchPerformances()
    } else {
      this.selectedEventId = this.eventId
    }
  },
  methods: {
    isArenaFanPitVenue() {
      return (
        !!this.venue &&
        [
          Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT,
          Venue.ARENA_ZAGREB_STOLOVI_FAN_PIT_BEZ_GORNJIH_SEKTORA,
        ].includes(this.venue.name)
      )
    },
    onSvgObjectLoad() {
      // Re-init pan/zoom and click handlers on each SVG load
      this.initPanZoom()
      this.changeSeatColors()

      const svgObject = document.getElementById('svgfile')
      if (!svgObject || !svgObject.getSVGDocument) return
      const svgDoc = svgObject.getSVGDocument()
      if (!svgDoc) return

      const svgRoot = svgDoc.documentElement
      if (!svgRoot) return

      // Click-vs-drag guard + unified seat click handling
      svgRoot.addEventListener(this.isMobile ? 'touchstart' : 'mousedown', this.handleSvgDown)
      svgRoot.addEventListener(this.isMobile ? 'touchend' : 'mouseup', this.handleSvgClick)
    },

    initPanZoom() {
      // Destroy previous instance (if any)
      if (window.panZoom && typeof window.panZoom.destroy === 'function') {
        try {
          window.panZoom.destroy()
        } catch (e) {
          // ignore
        }
      }

      let eventsHandler
      eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function (options) {
          let instance = options.instance,
            initialScale = 1,
            pannedX = 0,
            pannedY = 0

          // Init Hammer (pointer + touch)
          this.hammer = Hammer(options.svgElement, {
            inputClass: Hammer.SUPPORT_POINTER_EVENTS
              ? Hammer.PointerEventInput
              : Hammer.TouchInput,
          })

          // Enable pinch
          this.hammer.get('pinch').set({ enable: true })

          // Double tap to zoom in
          this.hammer.on('doubletap', function () {
            instance.zoomIn()
          })

          // Pan
          this.hammer.on('panstart panmove', function (ev) {
            if (ev.type === 'panstart') {
              pannedX = 0
              pannedY = 0
            }

            instance.panBy({
              x: ev.deltaX - pannedX,
              y: ev.deltaY - pannedY,
            })
            pannedX = ev.deltaX
            pannedY = ev.deltaY
          })

          // Pinch
          this.hammer.on('pinchstart pinchmove', function (ev) {
            if (ev.type === 'pinchstart') {
              initialScale = instance.getZoom()
              instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y })
            }

            instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y })
          })

          // Prevent page scroll while panning/zooming SVG
          options.svgElement.addEventListener('touchmove', function (e) {
            e.preventDefault()
          })
        },
        destroy: function () {
          this.hammer.destroy()
        },
      }

      // Use svg-pan-zoom on the current SVG object
      window.panZoom = svgPanZoom('#svgfile', {
        zoomEnabled: true,
        controlIconsEnabled: !this.isMobile,
        maxZoom: 7,
        fit: 1,
        center: 1,
        customEventsHandler: eventsHandler,
      })
    },

    handleSvgDown(e) {
      if (e.touches && e.touches.length) {
        this.clickStartX = e.touches[0].clientX
        this.clickStartY = e.touches[0].clientY
      } else {
        this.clickStartX = e.clientX
        this.clickStartY = e.clientY
      }
    },

    handleSvgClick(e) {
      let endX, endY
      if (e.changedTouches && e.changedTouches.length) {
        endX = e.changedTouches[0].clientX
        endY = e.changedTouches[0].clientY
      } else {
        endX = e.clientX
        endY = e.clientY
      }

      const delta = 6
      if (Math.abs(endX - this.clickStartX) > delta || Math.abs(endY - this.clickStartY) > delta) {
        return // drag/pan, not a click
      }

      const seatId = e && e.target && e.target.id
      if (!seatId) return

      // First try selection logic (available/disabled only)
      this.seatClickEventListener(e)

      // If seat is sold/reserved, open details modal
      const isSold = (this.orderItems || []).some(oi => (oi.soldSeats || []).includes(seatId))
      const isParterSold = (this.orderItems || []).some(
        item => item.itemMeta && item.itemMeta.parter && (item.soldSeats || []).includes(seatId),
      )
      if (isSold || isParterSold) {
        this.handleSeatClick(seatId)
      }
    },

    handleSelectOptions(option) {
      if (this.changeSelectOption === option) return
      this.unselectSeats()
      this.changeSelectOption = option
    },

    getSeatIdsCache(svgDoc) {
      if (this.seatIdsCache && this.seatIdsCache.length) return this.seatIdsCache
      if (!svgDoc) return []

      const nodes = svgDoc.querySelectorAll('[id*="Row-"][id*="Seat-"]')
      const ids = Array.from(nodes)
        .map(n => n && n.id)
        .filter(Boolean)

      this.seatIdsCache = Array.from(new Set(ids))

      return this.seatIdsCache
    },

    changeSeatColors() {
      this.addHoverSeatEventListeners()
      const svgDoc = document.getElementById('svgfile').contentDocument

      if (!svgDoc) return

      const existingReservedTexts = svgDoc.querySelectorAll('.reserved-seat-indicator')
      existingReservedTexts.forEach(text => text.remove())

      // Color available seats first
      for (const availableSeatId of this.availableSeats) {
        const circle = svgDoc.getElementById(availableSeatId)
        if (circle) {
          circle.style.fill = '#979797'
          circle.style.stroke = '#979797'
        }
      }

      // Color sold/taken seats (including subscriptions)
      for (const orderItem of this.orderItems) {
        const soldSeatsIds = orderItem.soldSeats || []
        const fillColor = orderItem.isSubscription
          ? SUBSCRIPTION_SEAT_COLOR
          : orderItem.selected
            ? orderItem.color
            : '#F5F5F5'
        const strokeColor = orderItem.isSubscription
          ? SUBSCRIPTION_SEAT_COLOR
          : orderItem.selected
            ? orderItem.color
            : '#a1a0a0'

        for (const seatId of soldSeatsIds) {
          const circle = svgDoc.getElementById(seatId)
          if (circle) {
            circle.style.stroke = strokeColor
            circle.style.fill = fillColor
          }
        }

        const reservedSeatsIds = orderItem.reservedSeats || []
        for (const seatId of reservedSeatsIds) {
          const circle = svgDoc.getElementById(seatId)
          if (!circle) continue

          circle.style.stroke = orderItem.selected ? orderItem.color : '#979797'
          circle.style.fill = orderItem.selected ? orderItem.color : '#D9D9D9'

          if (orderItem.selected) continue

          const cx = parseFloat(circle.getAttribute('cx'))
          const cy = parseFloat(circle.getAttribute('cy'))
          const r = parseFloat(circle.getAttribute('r'))
          let x = cx
          let y = cy

          // The text is a sibling of the circle, so it already inherits any parent
          // transforms (and the viewBox scale). Apply only the circle's own transform.
          const ownTransform = circle.transform && circle.transform.baseVal.consolidate()
          if (ownTransform) {
            const m = ownTransform.matrix
            x = m.a * cx + m.c * cy + m.e
            y = m.b * cx + m.d * cy + m.f
          }

          // Create the text element
          const text = document.createElementNS('http://www.w3.org/2000/svg', 'text')
          text.textContent = 'R'
          text.setAttribute('x', x)
          text.setAttribute('y', y)
          text.setAttribute('text-anchor', 'middle')
          text.setAttribute('dominant-baseline', 'middle')
          text.setAttribute('font-size', r * 1.2)
          text.setAttribute('fill', '#333333')
          text.setAttribute('font-family', '\'Source Sans Pro\', Arial, sans-serif')
          text.style.cursor = 'default'
          text.style.pointerEvents = 'none'
          text.classList.add(`reserved-seat-text-${orderItem.id}`)
          text.classList.add('reserved-seat-indicator')

          // Insert text after circle
          circle.parentNode.insertBefore(text, circle.nextSibling)
        }
      }

      // Color disabled seats
      for (const disabledSeatId of this.disabledSeats) {
        const circle = svgDoc.getElementById(disabledSeatId)
        if (circle) {
          circle.style.fill = '#D9D9D9'
          circle.style.stroke = '#D9D9D9'
        }
      }

      this.coloringInProgress = false

      // Mark interactive seats (sold or parter seats) and attach click listeners once
      this.setSeatPointerCursors()
      if (!this.svgClickListenersInitialized) {
        this.setupSvgSeatClickListeners()
        this.svgClickListenersInitialized = true
      }

      // Pan/zoom handled by svg-pan-zoom + Hammer (see initPanZoom)
    },
    handleOrderItemClick(orderItem) {
      orderItem.selected = !orderItem.selected
      this.changeSeatColors()
    },
    zoomIn() {
      if (!window.panZoom) return
      window.panZoom.zoomIn()
    },
    zoomOut() {
      if (!window.panZoom) return
      window.panZoom.zoomOut()
    },

    async fetchPerformances() {
      const {
        data: { getEventsByEventTemplateId },
      } = await this.$apollo.query({
        query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
        variables: {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        },
      })

      this.performanceDates = getEventsByEventTemplateId
        .sort((a, b) => new Date(b.from) - new Date(a.from))
        .map(p => {
          return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
        })
      this.selectedEventId = this.performanceDates[0].id || ''
    },

    checkIfSeatIsSold(seatId) {
      return !this.disabledSeats.includes(seatId) && !this.availableSeats.includes(seatId)
    },

    seatClickEventListener(e) {
      const seatCheck = ['Seat-', 'Row-']
      const svgDoc = document.getElementById('svgfile').getSVGDocument()

      const elementId = e.target.id
      if (
        !seatCheck.every(check => elementId.includes(check)) ||
        this.checkIfSeatIsSold(elementId)
      ) {
        return
      }

      const clickedSeatId = e.target.id

      if (!this.checkIfSeatHasTheSameType(clickedSeatId)) {
        this.snackbar = {
          open: true,
          messageProp: 'workflowsAll.only_seats_with_the_same_status_can_be_select_f7ca145',
          color: 'error',
        }

        return
      }

      // Seat mode (single)
      if (this.changeSelectOption === 1) {
        if (this.selectedSeatIds.includes(clickedSeatId)) {
          this.selectedSeatIds = this.selectedSeatIds.filter(seatId => seatId !== clickedSeatId)
          const seat = svgDoc.getElementById(clickedSeatId)
          if (this.disabledSeats.includes(clickedSeatId)) {
            seat.style.stroke = '#D9D9D9'
          } else {
            seat.style.stroke = '#979797'
          }
          seat.style.strokeWidth = '1'
        } else {
          this.selectedSeatIds.push(clickedSeatId)
          const seat = svgDoc.getElementById(clickedSeatId)
          seat.style.stroke = '#333333'
          seat.style.strokeWidth = '3.2'
        }

        return
      }

      const parsed = this.extractString(clickedSeatId)
      if (!parsed || !parsed.section || !parsed.row) return

      const allSeatIds = this.getSeatIdsCache(svgDoc)
      const clickedIsDisabled = this.disabledSeats.includes(clickedSeatId)

      let targetSeatIds = []
      if (this.changeSelectOption === 2) {
        const rowPrefix = `Section-${parsed.section}_Row-${parsed.row}_Seat-`
        targetSeatIds = allSeatIds.filter(id => id.startsWith(rowPrefix))
      } else if (this.changeSelectOption === 3) {
        const sectionPrefix = `Section-${parsed.section}_`
        targetSeatIds = allSeatIds.filter(id => id.startsWith(sectionPrefix))
      }

      // Only seats that are not SOLD/BOOKED and match clicked seat status (available/unavailable)
      targetSeatIds = targetSeatIds.filter(
        id => !this.checkIfSeatIsSold(id) && this.disabledSeats.includes(id) === clickedIsDisabled,
      )
      if (!targetSeatIds.length) return

      // Toggle whole row/group based on clicked seat being selected
      if (this.selectedSeatIds.includes(clickedSeatId)) {
        const toRemove = targetSeatIds.filter(id => this.selectedSeatIds.includes(id))
        this.selectedSeatIds = this.selectedSeatIds.filter(id => !toRemove.includes(id))
        for (const seatId of toRemove) {
          const seat = svgDoc.getElementById(seatId)
          if (!seat) continue
          seat.style.stroke = this.disabledSeats.includes(seatId) ? '#D9D9D9' : '#979797'
          seat.style.strokeWidth = '1'
        }
      } else {
        const toAdd = targetSeatIds.filter(id => !this.selectedSeatIds.includes(id))
        this.selectedSeatIds = [...this.selectedSeatIds, ...toAdd]
        for (const seatId of toAdd) {
          const seat = svgDoc.getElementById(seatId)
          if (!seat) continue
          seat.style.stroke = '#333333'
          seat.style.strokeWidth = '3.2'
        }
      }
    },

    async onSaveClick() {
      this.unselectSeats()
      const changedDisabledSeats = difference(this.disabledSeats, this.initialDisabledSeats)
      const changedAvailableSeats = difference(this.availableSeats, this.initialAvailableSeats)

      if (changedDisabledSeats.length) {
        const { errors } = await updateVenueAvailability({
          eventId: this.selectedEventId,
          seats: changedDisabledSeats,
          organizationSlug: this.organizationSlug,
          state: 'DISABLED',
          venueId: this.venue.id,
        })

        if (errors) {
          this.snackbar = {
            open: true,
            messageProp: errors[0].message,
            color: 'error',
          }
        }

        await this.fetchFloorPlanAvailabilityData()
      }

      if (changedAvailableSeats.length) {
        const { errors } = await updateVenueAvailability({
          eventId: this.selectedEventId,
          seats: changedAvailableSeats,
          organizationSlug: this.organizationSlug,
          state: SeatState.AVAILABLE,
          venueId: this.venue.id,
        })

        if (errors) {
          this.snackbar = {
            open: true,
            messageProp: errors[0].message,
            color: 'error',
          }
        }

        await this.fetchFloorPlanAvailabilityData()
      }

      // refresh SVG coloring after save
      this.changeSeatColors()
    },

    onRestartClick() {
      this.unselectSeats()
      this.disabledSeats = [...this.initialDisabledSeats]
      this.availableSeats = [...this.initialAvailableSeats]
      this.changeSeatColors()
      if (window.panZoom) {
        window.panZoom.resetZoom()
        window.panZoom.center()
      }
    },

    findSelectedSeatsType() {
      return `${this.disabledSeats.includes(this.selectedSeatIds[0]) ? 'un' : ''}available`
    },

    findOppositeSelectedSeatsType() {
      return this.findSelectedSeatsType() === 'available' ? 'unavailable' : 'available'
    },

    checkIfSeatHasTheSameType(seatId) {
      if (!this.selectedSeatIds.length) return true

      return (
        [this.selectedSeatIds[0], seatId].every(id => this.disabledSeats.includes(id)) ||
        [this.selectedSeatIds[0], seatId].every(id => !this.disabledSeats.includes(id))
      )
    },

    onChangeSeatStatus() {
      const svgDoc = document.getElementById('svgfile').getSVGDocument()
      const targetStatus = this.findOppositeSelectedSeatsType()

      for (const seatId of this.selectedSeatIds) {
        const seat = svgDoc.getElementById(seatId)
        if (targetStatus === 'unavailable') {
          seat.style.fill = '#D9D9D9'
          seat.style.stroke = '#D9D9D9'
          this.availableSeats = this.availableSeats.filter(id => id !== seatId)
          this.disabledSeats.push(seatId)
        } else {
          seat.style.fill = '#979797'
          seat.style.stroke = '#979797'
          this.disabledSeats = this.disabledSeats.filter(id => id !== seatId)
          this.availableSeats.push(seatId)
        }
        seat.style.strokeWidth = '1'
      }
      this.selectedSeatIds = []
    },

    async fetchFloorPlanAvailabilityData() {
      this.showFloorPlan = false
      this.coloringInProgress = true

      const { data } = await this.$apollo.query({
        query: GET_FLOOR_PLAN_AVAILABILITY_OVERVIEW_DATA,
        variables: { eventId: this.selectedEventId },
      })
      if (!data || !data.getFloorPlanAvailabilityOverviewData) {
        return (this.showFloorPlan = true)
      }
      const {
        venue,
        soldOrderItems,
        reservedOrderItems,
        availableSeats,
        disabledSeats,
        audienceCapacity,
      } = data.getFloorPlanAvailabilityOverviewData

      this.venue = venue
      this.seatHolders = []
      this.orderItems = soldOrderItems.map(item => {
        let reservedSeats = []
        const sameOrderItem = reservedOrderItems.find(reservedItem => reservedItem.id === item.id)
        if (sameOrderItem) {
          reservedSeats = sameOrderItem.seats
          item.ticketsNumber += sameOrderItem.ticketsNumber
          this.seatHolders.push(...sameOrderItem.seatHolders)
        }

        if (item.seatHolders) {
          this.seatHolders.push(...item.seatHolders)
        }

        return {
          ...item,
          soldSeats: item.seats,
          reservedSeats,
          // Ensure boolean flag exists for easier checks in UI
          isSubscription:
            typeof item.isSubscription !== 'undefined'
              ? item.isSubscription
              : item.type === OrderItemType.THEATER_SUBSCRIPTION,
          selected: false,
        }
      })
      this.reservedTicketsLength = sumBy(reservedOrderItems, item => item.ticketsNumber)
      this.availableSeats = availableSeats
      this.initialAvailableSeats = [...availableSeats]
      this.disabledSeats = disabledSeats
      this.initialDisabledSeats = [...disabledSeats]
      this.audienceCapacity = audienceCapacity + disabledSeats.length

      // Ensure subscription counts reflect actual SOLD seats for this event only
      this.orderItems = this.orderItems.map(oi => {
        const normalizedSold = Array.from(new Set(oi.soldSeats || []))
        const isSub = oi.isSubscription || oi.type === OrderItemType.THEATER_SUBSCRIPTION

        return {
          ...oi,
          soldSeats: normalizedSold,
          displayTicketsNumber: isSub ? normalizedSold.length : oi.ticketsNumber,
        }
      })

      this.coloringInProgress = false
      this.showFloorPlan = true
    },

    onResetAllClick() {
      // Backwards-compatible alias (deprecated by Restart button)
      this.onRestartClick()
    },

    addHoverSeatEventListeners() {
      const svgObject = document.querySelector('#svgfile')
      const svgDoc = svgObject && svgObject.contentDocument
      if (!svgDoc || this.isMobile) return

      svgDoc.addEventListener('mouseover', e => {
        const target = e && e.target
        const seatEl =
          target && target.id && target.id.includes('Row-')
            ? target
            : target && target.closest
              ? target.closest('[id*="Row-"]')
              : null

        if (seatEl && seatEl.id && seatEl.id.includes('Row-')) {
          this.showSeatInfo(seatEl.id, e)
        } else {
          this.hideSeatInfo()
        }
      })

      // If the pointer leaves the SVG entirely, ensure the tooltip is cleared.
      if (svgDoc.documentElement) {
        svgDoc.documentElement.addEventListener('mouseleave', () => this.hideSeatInfo())
      }
    },

    showSeatInfo(seat, event) {
      // Snapshot the tooltip location on enter; don't "follow" the mouse while staying on the same seat.
      if (this.seatInfoVisible && this.hoveredSeat === seat) return

      this.hoveredSeat = seat
      this.seatInfoVisible = true

      this.hoveredSeatHolderInfo = this.seatHolders.find(item => item.ticketLocation === seat)

      const relatedOrderItem = (this.orderItems || []).find(
        oi => (oi.soldSeats || []).includes(seat) || (oi.reservedSeats || []).includes(seat),
      )
      this.hoveredPlanName =
        relatedOrderItem &&
        (relatedOrderItem.isSubscription ||
          relatedOrderItem.type === OrderItemType.THEATER_SUBSCRIPTION)
          ? relatedOrderItem.name
          : null

      if (!event) return

      const svgObject = document.getElementById('svgfile')
      const svgRect = svgObject && svgObject.getBoundingClientRect ? svgObject.getBoundingClientRect() : null

      const viewportX = (svgRect ? svgRect.left : 0) + event.clientX
      const viewportY = (svgRect ? svgRect.top : 0) + event.clientY

      this.seatInfoPosition = {
        top: Math.max(0, viewportY) + 'px',
        left: Math.max(0, viewportX) + 'px',
      }
    },

    hideSeatInfo() {
      this.seatInfoVisible = false
      this.hoveredSeat = null
      this.seatInfoPosition = null
      this.hoveredSeatHolderInfo = null
      this.hoveredPlanName = null
    },

    extractString(inputString) {
      const match = inputString.match(/^Section-([^_]+)_Row-([^_]+)_Seat-([^_]+)$/)

      if (!match) {
        return { section: '', row: '', seat: '' }
      }

      const [, section, row, seat] = match

      return { section, row, seat }
    },

    unselectSeats() {
      const svgDoc = document.getElementById('svgfile').getSVGDocument()
      for (const seatId of this.selectedSeatIds) {
        const seat = svgDoc.getElementById(seatId)
        if (seat) {
          if (this.disabledSeats.includes(seatId)) {
            seat.style.stroke = '#D9D9D9'
          } else {
            seat.style.stroke = '#979797'
          }
          seat.style.strokeWidth = '1'
        }
      }
      this.selectedSeatIds = []
    },

    setSeatPointerCursors() {
      const svgDoc = document.getElementById('svgfile').contentDocument
      if (!svgDoc) return

      const soldSeatIds = new Set(
        (this.orderItems || []).flatMap(oi => Array.from(new Set(oi.soldSeats || []))),
      )

      for (const seatId of soldSeatIds) {
        const seatElement = svgDoc.getElementById(seatId)
        if (!seatElement) continue

        const isParterSold = (this.orderItems || []).some(
          item => item.itemMeta && item.itemMeta.parter && (item.soldSeats || []).includes(seatId),
        )

        if (seatElement && (soldSeatIds.has(seatId) || isParterSold)) {
          seatElement.style.cursor = 'pointer'
        }
      }
    },

    setupSvgSeatClickListeners() {
      const svgDoc = document.getElementById('svgfile').contentDocument
      if (!svgDoc) return

      svgDoc.addEventListener(this.isMobile ? 'touchstart' : 'mousedown', e => {
        if (this.isMobile) {
          this.multiTouch = e.touches && e.touches.length > 1
          this.startY = e.touches ? e.touches[0].clientY : null
          this.startX = e.touches ? e.touches[0].clientX : null
        } else {
          this.startY = e.pageY
          this.startX = e.pageX
        }
      })

      svgDoc.addEventListener(this.isMobile ? 'touchend' : 'mouseup', event => {
        if (this.updatingFloorPlan) return

        const seatId = event.target && event.target.id
        if (!seatId) return

        const delta = 6
        const diffX = Math.abs(
          this.isMobile && event.changedTouches
            ? event.changedTouches[0].clientX - this.startX
            : event.pageX - this.startX,
        )
        const diffY = Math.abs(
          this.isMobile && event.changedTouches
            ? event.changedTouches[0].clientY - this.startY
            : event.pageY - this.startY,
        )
        if (!this.multiTouch && diffX < delta && diffY < delta) {
          const isSold = (this.orderItems || []).some(oi => (oi.soldSeats || []).includes(seatId))
          const isParterSold = (this.orderItems || []).some(
            item =>
              item.itemMeta && item.itemMeta.parter && (item.soldSeats || []).includes(seatId),
          )

          if (isSold || isParterSold) {
            this.handleSeatClick(seatId)
          }
        }
      })
    },

    async handleSeatClick(seatId) {
      const data = await getFloorPlanOverviewSeatDetailsByTicketLocation(
        this.selectedEventId,
        seatId,
      )

      if (!data || !data.length) return

      this.selectedSeatData = {
        data: data[0],
        numberOfSeats: data.length,
        orderItem: data[0].purchases.orderItem,
      }
      this.seatDetailsModalVisible = true
    },

    closeSeatDetailsModal() {
      this.seatDetailsModalVisible = false
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .wrapper {
    margin-top: 1.5rem;
  }

  .controls-wrapper {
    flex-direction: column;
  }

  .controls-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

.floor-plan-wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  flex: 1 1 42.75rem;
  min-width: 320px;
}

.floor-plan-container {
  padding: 3rem;
  position: relative;
  overflow: auto;
  width: 100%;
}

.object-container {
  overflow: auto;
  position: relative;

  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: white;
}

.object-container::-webkit-scrollbar {
  display: none;
}

.floor-plan-overview-wrapper {
  display: flex;
  gap: 1.4375rem;
  flex-wrap: wrap;
  align-items: flex-start;
}

/* Side panel: wraps under automatically when there's no space */
.floor-plan-overview-wrapper > .tickets-container:not(.tickets-container--below) {
  flex: 0 1 22.125rem;
  width: 22.125rem;
  max-width: 100%;
}

.card-title {
  display: flex;
  padding: 1rem 1.5rem;
  align-items: center;
  gap: 0.4375rem;
  background-color: #f5f5f5;
  width: 100%;

  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}

.controls-wrapper {
  display: flex;
  padding: 1rem 1.5rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  width: 100%;
  justify-content: space-between;
}

.floor-plan-toggle {
  display: flex;
  gap: 6px;
  padding: 4px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.floor-plan-toggle-btn {
  display: flex;
  align-items: center;
  column-gap: 4px;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
}

.floor-plan-toggle-btn--active {
  pointer-events: none;
  background: #fff;
  border: 1px solid #d9d9d9;
}

.floor-plan-toggle-btn--active .floor-plan-button-text {
  color: #0277bd;
}

/* Approximate blue tint for active SVG icons */
.floor-plan-toggle-btn--active .floor-plan-toggle-icon {
  filter: invert(32%) sepia(88%) saturate(1600%) hue-rotate(186deg) brightness(92%) contrast(105%);
}

.floor-plan-toggle-icon {
  width: 18px;
  height: 18px;
}

.floor-plan-button-text {
  color: var(--Grey-10, #666);
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-left: 4px;
}

.controls-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.restart-btn {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  border: 2px solid #0277bd;
  background: #fff;
  color: #0277bd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.restart-btn:hover {
  cursor: pointer;
}

.save-btn {
  height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  border: 2px solid #1e73be;
  background: #1e73be;
  color: #fff;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.save-btn:hover {
  cursor: pointer;
}

.manage-floor-plan {
  display: flex;
  padding: 0.25rem 0.75rem;
  align-items: center;
  gap: 0.4375rem;
  background-color: white;
  border-radius: 0.25rem;

  color: #0277bd;
  font-family: 'Source Sans Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.manage-floor-plan:hover {
  cursor: pointer;
}

.controls-buttons {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.tickets-container {
  display: flex;
  width: 30.125rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  height: fit-content;
  border-radius: 0.5rem 0 0 0.5rem;
  border: 2px solid #f5f5f5;
  background: #f5f5f5;
}

.tickets-container--below {
  width: 100%;
  border-radius: 0 0 0.75rem 0.75rem;
  border-top: 2px solid #f5f5f5;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.mark-as-wrapper {
  display: flex;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
  background-color: white;
}

.mark-as-title {
  color: #666;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.03rem;
}

.mark-unavailable-btn {
  width: 100%;
  height: 44px;
  border-radius: 999px;
  border: 1px solid #d9d9d9;
  background: #f5f5f5;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
}

.mark-unavailable-btn:disabled {
  cursor: default;
  opacity: 0.6;
}

.mark-unavailable-btn:not(:disabled) {
  cursor: pointer;
  background: white;
  color: #666;
  border: 1px solid #e9e9e9;
}

.mark-unavailable-btn.mark-unavailable-btn--ready {
  border: 1px solid #e9e9e9;
  background: #fff;
}

.mark-unavailable-btn.mark-unavailable-btn--marked {
  background: #0277bd;
  border: 1px solid #0277bd;
  color: #fff;
}

.mark-unavailable-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mark-unavailable-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mark-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
}

.mark-unavailable-btn--ready .mark-dot {
  background: #f7dfe4;
  border: 1px solid #f7dfe4;
}

.mark-unavailable-btn--marked .mark-dot {
  background: transparent;
  border: 2px solid #fff;
}

.mark-link-icon {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #e7f2fa;
  color: #0277bd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.mark-check {
  font-size: 18px;
}

.mark-as-text {
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.available-stats-container {
  display: flex;
  padding: 1rem 1.5rem;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;

  background-color: white;
}

.base-text {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.bold-text {
  font-weight: 700;
}

.ticket-types-container {
  display: flex;
  padding: 1rem 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;

  background-color: white;
}

.circle {
  width: 1rem;
  height: 1rem;
  border-radius: 10000px;
}

.price-amount {
  color: #979797;
  leading-trim: both;
  text-edge: cap;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.additional-seat-info-container {
  display: flex;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;

  background-color: white;
}

.additional-seat-info-title {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.03rem;
}

.additional-items {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.sold-circle {
  background: #f5f5f5;
  border: 1px solid #a1a0a0;
}

.booked-circle {
  background: #d9d9d9;
  border: 1px solid #979797;
  color: #333333;
  font-size: 10px;
  text-align: center;
}

.available-circle {
  background: #979797;
}

.unavailable-circle {
  background: #d9d9d9;
}

.subscription-circle {
  background: #800080;
  border: 1px solid #800080;
}

.selected-circle-available {
  background: #979797;
  border: 3px solid #333;
}

.selected-circle-unavailable {
  background: #d9d9d9;
  border: 3px solid #333;
}

.bkg-color-blue {
  background-color: #e6f1f8;
}

.managing-controls {
  display: flex;
  flex-direction: row-reverse;
  padding: 1rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.reset-all-button {
  display: flex;
  height: 3rem;
  padding: 0.75rem 0.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  border-radius: 1.5rem;
  background: rgba(255, 255, 255, 0);
}

.reset-all-button:hover {
  cursor: pointer;
  background: white;
}

.reset-all-text {
  color: #0277bd;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;

  font-family: Raleway;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.01688rem;
  text-transform: uppercase;
}

.link-icon {
  display: flex;
  padding: 0.25rem;
  align-items: center;
  gap: -0.0625rem;

  border-radius: 1.5rem;
  background: #e6f1f8;
}

.tooltip {
  background-color: #333333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 0.125rem 0.625rem;
  position: fixed;
  transform: translate(-50%, calc(-100% - 0.5rem));
  z-index: 1;
  width: 80px;
  pointer-events: none;

  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
}
</style>
